import { Dialog, makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC, useState } from "react"
import { useOrganization } from "../../hooks/useOrganization"
import { useUser } from "../../hooks/useUser"
import { colors } from "../../utils/theme"
import { GhostButton, PrimaryButton } from "../atoms/button/Button"
import CloseIcon from "../atoms/CloseIcon"
import Input from "../atoms/input/Input"

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    border: `1px solid ${colors.neutral.clay}`,
    boxShadow: "none",
    overflow: "visible",
  },
  dialogCloseContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
  },
  closeButton: {
    margin: 0,
    padding: 0,
    border: 0,
    height: theme.spacing(2),
    width: theme.spacing(2),
    backgroundColor: "transparent",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
    },
  },
  dialogTitle: {
    color: colors.neutral.denim,
    marginBottom: theme.spacing(3),
  },
  dialogSubtitle: {
    color: colors.neutral.denim,
    marginBottom: theme.spacing(3),
  },
  dialogButton: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  cancelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  marginBottom24: {
    marginBottom: theme.spacing(3),
  },
  input: {
    width: "100%",
  },
}))

const EditOrgNameDialog: FC<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  const classes = useStyles()
  const { user } = useUser()
  const { updateName } = useOrganization()
  const [name, setName] = useState<string>(user?.organizations?.[0]?.name ?? "")
  const [nameError, setNameError] = useState<boolean>(false)

  return (
    <Dialog
      fullWidth={true}
      maxWidth="xs"
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <div className={classes.dialogContent}>
        <div className={classes.dialogCloseContainer}>
          <button className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <Typography variant="h2" component="h1" className={classes.dialogTitle}>
          Edit Organization Name
        </Typography>
        <Input
          value={name}
          onChange={(event) => setName(event.target.value)}
          error={nameError}
          className={clsx(classes.marginBottom24, classes.input)}
          label="Organization Name"
          placeholder="Organization Name"
        />
        <PrimaryButton
          onClick={async () => {
            setNameError(false)
            if (!name) {
              setNameError(true)
              return
            }
            await updateName(name)
            onClose()
          }}
          className={classes.dialogButton}
          type="submit"
        >
          Save
        </PrimaryButton>
        <div className={classes.cancelContainer}>
          <GhostButton onClick={onClose}>Cancel</GhostButton>
        </div>
      </div>
    </Dialog>
  )
}

export default EditOrgNameDialog
